import $ from 'jquery';
const nameRegex = /^[a-zA-ZàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœőŐűŰ \.\-]{5,50}$/;
const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const phoneRegex = /^\+?[0-9]{2,20}$/;

export const PromotionComponent = {
	bindings: {
	},
	transclude: true,
	templateUrl: 'promotion.html',
	controller: class PromotionComponent {
		constructor($http, $timeout) {
			'ngInject';
			this.http = $http;
			this.showForm = false;
			this.showSuccessMessage = false;
			this.captchaInfo = {};
			this.nameRegex = nameRegex;
			this.emailRegex = emailRegex;
			this.phoneRegex = phoneRegex;
			this.$timeout = $timeout;
			this.model = {
				phone: '+36',
				q2_1: false,
				q2_2: false,
				q2_3: false,
				q2_4: false,
				q2_5: false
			};
		}

		$onInit() {
		}

		// API
		getCaptchaInfo() {
			this.http.get('/public/captcha').then(response => {
				this.captchaInfo.id = response.data.captchaId;
				this.captchaInfo.htmlFragment = response.data.htmlFragment;
			}, err => {
				console.log(err.data);
			});
		}

		checkEmailExists() {
			if (this.emailRegex.test(this.model.email)) {
				this.http.get(`/public/promo/email?email=${this.model.email}`).then(() => {
					// nincs ilyen mailcímmel adat, mehet be
					this.promotionFrom.email.$setValidity('exist', true);
				}, () => {
					this.promotionFrom.email.$setValidity('exist', false);
				});
			}
		}

		goToHomePage() {
			window.location.href = '/';
		}

		sendForm() {
			// mikor újra küldjük, kiütjük a szerverről jövő validációt
			this.promotionFrom.captcha.$setValidity('text', true);
			if (this.promotionFrom.$valid) {
				this.http({
					method: 'post',
					url: '/public/promo',
					data: this.model,
					headers: {
						captcha: JSON.stringify({
							captchaId: `${this.captchaInfo.id}`,
							captchaText: `${this.captchaInfo.text}`
						})
					}
				}).then(() => {
					this.showSuccessMessage = true;
					window.dataLayer.push({ 'event': 'contestRegistrationSuccess' })
					this.$timeout(() => {
						this.scrollTop();
					});
				}, err => {
					if (err.status === 400 && err.data?.error == 'captcha') {
						this.promotionFrom.captcha.$setValidity('text', false);
						this.getCaptchaInfo();
						this.scrollToFirstError();
					}
				});
			} else {
				this.scrollToFirstError();
			}
		}

		startGame() {
			this.getCaptchaInfo();
			this.showForm = true;
			this.scrollTop();
		}

		someSelected() {
			return this.model.q2_1 || this.model.q2_2 || this.model.q2_3 || this.model.q2_4 || this.model.q2_5;
		}

		scrollTop() {
			$('.ip-content-container').animate({
				scrollTop: 200
			}, 500);
		}

		scrollToFirstError() {
			this.$timeout(() => {
				let elements = $('.md-input-message-animation');
				if (elements.length) {
					let options = { behavior: 'smooth' };
					let first = elements[0];
					first.scrollIntoView(options);
				}
			}, 500);
		}
	}
};
